import {normalizeHandNotes} from '../../components/editors/handwritingModel';

const storagePrefix='STORAGE_JSON:';
const bytes=value=>new Blob([JSON.stringify(value)]).size;

// Keep growing handwriting out of the Firestore document size limit. The
// lecture's existing Storage folder holds the full, lossless notebook JSON.
export async function prepareHandNotesForSave(draft,upload) {
    if(!draft.handNotes)return draft.handNotes;
    if(bytes(draft.handNotes)<400000 && bytes(draft)<750000)return draft.handNotes;
    return storagePrefix+await upload(JSON.stringify(draft.handNotes));
}

export async function resolveHandNotes(value) {
    if(typeof value==='string' && value.startsWith(storagePrefix)){
        const response=await fetch(value.slice(storagePrefix.length),{cache:'no-store'});
        if(!response.ok)throw new Error('The saved handwriting could not be downloaded.');
        value=await response.json();
        if(!value || !value.drawings || !Array.isArray(value.drawings.strokes))throw new Error('The saved handwriting file is invalid.');
    }
    return value?normalizeHandNotes(value):null;
}
